
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PropBotForm } from '@/components/admin/prop-trading/PropBotForm';
import { useCreatePropBot } from '@/hooks/use-admin-prop-bots';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';

const PropBotAddPage = () => {
  const navigate = useNavigate();
  const { mutateAsync: createPropBot, isPending } = useCreatePropBot();

  const handleCreatePropBot = async (data: any) => {
    if (isPending) return; // Prevent double submit
    
    try {
      await createPropBot(data);
      // Navigate back to the prop bots list after successful creation
      navigate('/admin/prop-trading');
    } catch (error) {
      console.error('Error creating prop bot:', error);
      // Toast is handled in the mutation hook
    }
  };

  return (
    <div className="container py-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => navigate('/admin/prop-trading')}
            className="mb-4"
          >
            <ChevronLeft className="h-4 w-4 mr-1" />
            Back to List
          </Button>
          <h1 className="text-2xl font-bold tracking-tight">Add New Prop Trading Bot</h1>
          <p className="text-muted-foreground">
            Create a new prop trading bot with details and trading parameters.
          </p>
        </div>
      </div>
      
      <PropBotForm 
        onSubmit={handleCreatePropBot} 
        isLoading={isPending}
        mode="add"
      />
    </div>
  );
};

export default PropBotAddPage;
